import { IMPORT_EQUIPMENT, IMPORT_EQUIPMENT_CLEAR_REDIRECT } from "./actions";

export const OnboardingStep1ClassName = 'equipment-import-onboarding-step-1';
export const OnboardingStep2ClassName = 'equipment-import-onboarding-step-2';

const defaultState = {
  importing: false,
  readOnly: false,
  onboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Films',
      content: `        
        Select which film you want to copy equipment from.
      `
    },
    {
      target: '.' + OnboardingStep2ClassName,
      title: 'Copy',
      content: `Click the copy button to copy the equipment.`
    }

  ]
};


const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case IMPORT_EQUIPMENT + "_PENDING": {
      return {
        ...state,
        errors: null,
        importing: true
      };
    }

    case IMPORT_EQUIPMENT + "_FULFILLED": {
      return {
        ...state,
        importing: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case IMPORT_EQUIPMENT + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        importing: false
      };
    }

    case IMPORT_EQUIPMENT_CLEAR_REDIRECT: {
      return {
        ...state,
        department: null,
        redirect: null
      };
    }

    default:
      return state;
  }
};

export default reducer;
